const translations = {
    applicationLabel: 'Application',
    assetLabel: 'Asset',
    boundaryLabel: 'Boundary',
    clientLabel: 'Client',
    farmLabel: 'Farm',
    fieldLabel: 'Field',
    memberLabel: 'Member'
};

export default translations;
